import { render, staticRenderFns } from "./establishRoll.vue?vue&type=template&id=0ee1760c&scoped=true&"
import script from "./establishRoll.vue?vue&type=script&lang=js&"
export * from "./establishRoll.vue?vue&type=script&lang=js&"
import style0 from "./establishRoll.vue?vue&type=style&index=0&id=0ee1760c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee1760c",
  null
  
)

export default component.exports